module.exports = {
  factory: function velocity() {
    return {
      vx: 0,
      vy: 0
    }
  },
  reset: function(velocity) {
    velocity.vx = 0;
    velocity.vy = 0;
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/velocity.js
// module id = 191
// module chunks = 0